/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSavedPaymentMethod200ResponseProvider
 */
export interface GetSavedPaymentMethod200ResponseProvider {
}

/**
 * Check if a given object implements the GetSavedPaymentMethod200ResponseProvider interface.
 */
export function instanceOfGetSavedPaymentMethod200ResponseProvider(value: object): value is GetSavedPaymentMethod200ResponseProvider {
    return true;
}

export function GetSavedPaymentMethod200ResponseProviderFromJSON(json: any): GetSavedPaymentMethod200ResponseProvider {
    return GetSavedPaymentMethod200ResponseProviderFromJSONTyped(json, false);
}

export function GetSavedPaymentMethod200ResponseProviderFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSavedPaymentMethod200ResponseProvider {
    return json;
}

export function GetSavedPaymentMethod200ResponseProviderToJSON(json: any): GetSavedPaymentMethod200ResponseProvider {
    return GetSavedPaymentMethod200ResponseProviderToJSONTyped(json, false);
}

export function GetSavedPaymentMethod200ResponseProviderToJSONTyped(value?: GetSavedPaymentMethod200ResponseProvider | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

